import { PersonalDashboardComponent } from './pages/personal-dashboard/personal-dashboard.component';
import { FamilyComponent }           from './pages/family/family.component';
import { AllmyhugsComponent }        from './pages/allmyhugs/allmyhugs.component';
import { NorametricsComponent }      from './pages/norametrics/norametrics.component';
import { NewsrespondersComponent }   from './pages/newsresponders/newsresponders.component';
import { MonasteryComponent }        from './pages/monastery/monastery.component';
import { EducationComponent }        from './pages/education/education.component';
import { TravelComponent }           from './pages/travel/travel.component';
import { CommunitydevComponent }     from './pages/communitydev/communitydev.component';
import { RemotecareerboardComponent }from './pages/remotecareerboard/remotecareerboard.component';
import { BizbasebeginComponent }     from './pages/bizbasebegin/bizbasebegin.component';
import { LifebasebeginComponent }    from './pages/lifebasebegin/lifebasebegin.component';
import { AntisocialmediaComponent }  from './pages/antisocialmedia/antisocialmedia.component';
import { HowjyadoitComponent }       from './pages/howjyadoit/howjyadoit.component';
import { LobbyhobbiesComponent }     from './pages/lobbyhobbies/lobbyhobbies.component';
import { HopesanddreamsComponent }   from './pages/hopesanddreams/hopesanddreams.component';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'; // or import NgbPopoverModule if you only need popovers

// Utilities
import { RouteReuseStrategy } from '@angular/router';
import { CustomReuseStrategy } from '../app/utilities/custom-reuse-strategy';
import { DashboardGridComponent } from './utilities/dashboard-grid/dashboard-grid.component';

// pipes
import { SafePipe } from './utilities/pipes/safe.pipe';
import { TitlecasePipe } from './utilities/pipes/titlecase.pipe';

//front door
import { LoginComponent } from './frontdoor/login/login.component';
import { PublicLandingComponent } from './shared/landings/public-landing/public-landing.component';
import { NavbarComponent } from './interfaceElements/navbar/navbar.component';


import { ForgotComponent } from './frontdoor/forgot/forgot.component';
import { ResetComponent } from './frontdoor/reset/reset.component';
import { SignupComponent } from './frontdoor/signup/signup.component';
import { MyaccountComponent } from './obligatorypages/myaccount/myaccount.component';


import { PageEditorComponent } from './utilities/page-editor/page-editor.component';

import { SettingsComponent } from './adminTools/settings/settings.component';

import { AdminDashboardComponent } from './adminTools/admin-dashboard/admin-dashboard.component';


// full calendar install modules
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// 1) The Angular FullCalendar wrapper module
import { FullCalendarModule } from '@fullcalendar/angular';

import { AboutusComponent } from './obligatorypages/aboutus/aboutus.component';

import { ContactComponent } from './obligatorypages/contact/contact.component';
import { SupportComponent } from './obligatorypages/support/support.component';
import { TosComponent } from './obligatorypages/tos/tos.component';


import { LandingPageComponent } from './shared/landings/landing-page/landing-page.component';

import { RegistereduserlandingComponent } from './shared/landings/registereduserlanding/registereduserlanding.component';
import { PaiduserlandingComponent } from './shared/landings/paiduserlanding/paiduserlanding.component';
import { RecipientuserlandingComponent } from './shared/landings/recipientuserlanding/recipientuserlanding.component';
import { AdminuserlandingComponent } from './shared/landings/adminuserlanding/adminuserlanding.component';
import { MysettingsComponent } from './obligatorypages/mysettings/mysettings.component';
import { FaqComponent } from './obligatorypages/faq/faq.component';
import { PhotoalbumsComponent } from './shared/innerapps/photoalbums/photoalbums.component';
import { ForyouComponent } from './pages/foryou/foryou.component';
import { MyproductsComponent } from './pages/myproducts/myproducts.component';
import { AdminComponent } from './adminTools/admin/admin.component';








@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PublicLandingComponent,
    NavbarComponent,
    ForgotComponent,
    ResetComponent,
    SignupComponent,
    MyaccountComponent,
    SettingsComponent,
    AdminDashboardComponent,
    AboutusComponent,
    ContactComponent,
    SupportComponent,
    TosComponent,
    SafePipe,
    LandingPageComponent,
    RegistereduserlandingComponent,
    PaiduserlandingComponent,
    RecipientuserlandingComponent,
    AdminuserlandingComponent,
    MysettingsComponent,
    FaqComponent,
    PhotoalbumsComponent,
    ForyouComponent,
    MyproductsComponent,
    AdminComponent,
    TitlecasePipe,
    PageEditorComponent,
    DashboardGridComponent,
    PersonalDashboardComponent,
    FamilyComponent,
    AllmyhugsComponent,
    NorametricsComponent,
    NewsrespondersComponent,
    MonasteryComponent,
    EducationComponent,
    TravelComponent,
    CommunitydevComponent,
    RemotecareerboardComponent,
    BizbasebeginComponent,
    LifebasebeginComponent,
    AntisocialmediaComponent,
    HowjyadoitComponent,
    LobbyhobbiesComponent,
    HopesanddreamsComponent
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    FullCalendarModule,  // include the FullCalendarModule here
    NgbModule
  ],
  providers: [ {provide: RouteReuseStrategy, useClass: CustomReuseStrategy } ],
  bootstrap: [AppComponent]
})
export class AppModule { }
